import { render, staticRenderFns } from "./SharedArtworkPreview.vue?vue&type=template&id=21b04610&scoped=true"
import script from "./SharedArtworkPreview.vue?vue&type=script&lang=js"
export * from "./SharedArtworkPreview.vue?vue&type=script&lang=js"
import style0 from "./SharedArtworkPreview.vue?vue&type=style&index=0&id=21b04610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b04610",
  null
  
)

export default component.exports